export const WATERMARK_POWERED_BY_BOOST_URL =
  'https://boostcommerce.net/?utm_source=customer&utm_medium=store&utm_campaign=BoostFree';
